import styled from 'styled-components';
import { GridStandaloneCol } from '@lux/grid';
export const StyledGridStandaloneCol = styled(GridStandaloneCol).withConfig({ displayName: "StyledGridStandaloneCol", componentId: "sc-1dd1ex3" }) `scroll-snap-align:start;`;
//# sourceMappingURL=styles.js.map